import React from "react";
import {Dimension, DimensionValue, OrientedTile, PositionInSquare, RotationType} from "../../models/tile";
import styles from './Tile.module.css';
import {blurTile, chooseTile, focusOnTile, rotateTile, TileLocation} from "../game/gameSlice";
import {useAppDispatch,} from "../../app/hooks";
import {useDrag} from "react-dnd";

type QuadrantProps = {
    position: PositionInSquare;
    dimension: Dimension;
    value: DimensionValue;
}

export function TileQuadrant(props: QuadrantProps) {
    const iconClass = `icon-${props.dimension}-${props.value}`;
    return (
        <div
            className={`${styles.quadrant} ${styles[props.position]} ${styles[iconClass]}`}
        />
    )
}


type TileRotatorProps = {
    location: TileLocation,
    rotationType: RotationType,
}


const tileRotatorClass = (rotationType: RotationType) => {
    switch (rotationType) {
        case "rotateClockwise":
            return styles.rotateClockwise;
        case "flipHorizontal":
            return styles.flipHorozontal;
        case "flipVertical":
            return styles.flipVertical;
    }
    console.warn(`Could not fund rotation class for ${rotationType}`);
    return "";
}


const TileRotator = ({location, rotationType}: TileRotatorProps) => {
    const dispatch = useAppDispatch();
    const className = [
        styles.rotator,
        tileRotatorClass(rotationType)
    ].join(" ");
    return (
        <div
            className={className}
            onClick={() => {
                dispatch(rotateTile({location: location, rotationType}))
            }}
        />
    )
}


type TileProps = {
    tile: OrientedTile,
    location: TileLocation,
    isFocussed?: boolean,
    isChosen?: boolean,
    rotationTypes?: RotationType[],
}


const deviceHasCoursePointer = window.matchMedia("(pointer: coarse)").matches;


export function Tile({tile, location, isFocussed, isChosen, rotationTypes}: TileProps) {
    const dispatch = useAppDispatch();
    const displayRotators = ! deviceHasCoursePointer;
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'PLACE_TILE',
        item: location,
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        })
    }))
    const classNames = [styles.tile];
    if (isFocussed) {
        classNames.push(styles.focussed);
    }
    if (isDragging) {
        classNames.push(styles.dragging);
    }
    if (isChosen) {
        classNames.push(styles.chosen);
    }
    return (
      <span
          ref={drag}
          className={classNames.join(" ")}
          style={{
              opacity: isDragging ? 0.5: 1,
          }}
          onPointerEnter={() => {
              dispatch(focusOnTile(location))
          }}
          onPointerLeave={() => {
              dispatch(blurTile())
          }}
          onTouchStart={() => {
              dispatch(focusOnTile(location))
              dispatch(chooseTile(location))
          }}
      >
          <TileQuadrant position="left" dimension={tile.left.dimension} value={tile.left.value}/>
          <TileQuadrant position="top" dimension={tile.top.dimension} value={tile.top.value}/>
          <TileQuadrant position="right" dimension={tile.right.dimension} value={tile.right.value}/>
          <TileQuadrant position="bottom" dimension={tile.bottom.dimension} value={tile.bottom.value}/>
          { displayRotators && rotationTypes && rotationTypes.map((rotationType, key) => <TileRotator
              key={key}
              location={location}
              rotationType={rotationType}
          />) }
      </span>
    )
}
